import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Container, Grid2 } from "@mui/material";
import { Link } from "react-router-dom";
import BlogCard from "../../blog-card/blogCard";
import { collection, getDocs } from "firebase/firestore"; // Import Firestore functions
import { db } from "../../../firestore-DB-config/firebase-config"; // Ensure to import your Firestore configuration

interface Blog {
  id: string;
  date: string;
  title: string;
  cardDescription: string;
  description: string;
  author: string;
  datePublished: string;
  blogImageUrl: string;
  authorImageUrl: string;
  slug: string;
}

const BlogSection: React.FC = () => {
  const [blogs, setBlogs] = useState<Blog[]>([]); // State for blogs
  const [loading, setLoading] = useState(true); // State for loading status

  // Fetch blogs function
  const fetchBlogs = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "blogs"));
      const blogList: Blog[] = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })) as Blog[];
      setBlogs(blogList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching blog posts: ", error);
      setLoading(false);
    }
  };

  // useEffect to fetch blogs on component mount
  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <Container sx={{ my: { xs: 6, md: 8 }, px: { xs: 4.5, md: 4, lg: 0 } }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        flexDirection={{ xs: "column", md: "row" }}
      >
        <Box textAlign="left">
          <Container>
            <Typography
              variant="h5"
              textAlign="left"
              fontWeight={700}
              color="rgba(1, 29, 51, 1)"
              gutterBottom
              sx={{ fontSize: { xs: "22px", sm: "28px" } }}
            >
              WHATS TRENDING
            </Typography>
            <Typography
              variant="h4"
              textAlign="left"
              fontWeight={540}
              mb={2}
              color="rgba(1, 29, 51, 1)"
              sx={{ fontSize: { xs: "24px", sm: "32px" } }} // Responsive subheading
            >
              LATEST BLOGS & POSTS
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#7A7A7A",
                marginBottom: "20px",
                fontSize: { xs: "14px", sm: "16px" },
              }}
            >
              Donec Porttitor Euismod Dignissim. Nullam A Lacinia Ipsum, Nec
              Dignissim Purus. Nulla Convallis Ipsum Molestie Nibh Malesuada.
            </Typography>
          </Container>
        </Box>

        <Button
          variant="outlined"
          sx={{
            borderRadius: 4,
            mt: { xs: 2, md: 0 },
            px: "26px",
            textTransform: "none", 
            transition: "background-color 0.3s, transform 0.3s",
            "&:hover": {
              transform: "scale(1.1)",
            },
          }}
          component={Link}
          to="/blogs"
          onClick={() => window.scrollTo(0, 0)}
        >
          View All
        </Button>
      </Box>

      {loading ? (
        <Typography variant="body1" align="center">
          Loading...
        </Typography>
      ) : (
        <Grid2
        container
        spacing={ {xs: 3, sm: 6} }
        justifyContent={{ xs: "center", md: "left" }}
      >
          {/* Only show the first 3 blogs */}
          {blogs.slice(0, 3).map((blog) => (
            <Grid2
              size={{ xs: 10, md: 6, lg: 4 }}
              key={blog.id}
            >
              <BlogCard blog={blog} />
            </Grid2>
          ))}
        </Grid2>
      )}
    </Container>
  );
};

export default BlogSection;
